import { PAGE, ROUTES_CONFIG } from '@/modules/page/routes';

import { useTranslation } from 'react-i18next';
import { Params, useLocation, useNavigate, useParams } from 'react-router-dom';

export function useNavigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const { t } = useTranslation();

  const goBack = () => {
    navigate(-1);
  };

  const goTo = (page: string, params?: Params) => {
    let compiledPath = `/${page}`;
    if (params) {
      compiledPath = Object.keys(params).reduce(
        (acc, key) => acc.replace(`:${key}`, String(params[key])),
        compiledPath,
      );
    }
    navigate(compiledPath);
  };

  const currentPageWithParams = () => {
    const pathSegments = location.pathname.split('/').filter(Boolean);

    const sortedRoutes = Object.values(PAGE).sort((a, b) => {
      const aSegments = a.split('/');
      const bSegments = b.split('/');

      const aHasParam = aSegments.some((seg) => seg.startsWith(':'));
      const bHasParam = bSegments.some((seg) => seg.startsWith(':'));

      if (aHasParam && !bHasParam) return 1;
      if (!aHasParam && bHasParam) return -1;

      return bSegments.length - aSegments.length;
    });

    const matchingRoute = sortedRoutes.find((route) => {
      const routePath = `/${route}`.replace(/\/+$/, '');
      const routeSegments = routePath.split('/').filter(Boolean);

      if (route === '' && location.pathname === '/') return true;
      if (routeSegments.length !== pathSegments.length) return false;

      return routeSegments.every(
        (seg, i) => seg.startsWith(':') || seg === pathSegments[i],
      );
    });

    return { page: matchingRoute, params };
  };

  const currentPage = currentPageWithParams();

  return {
    goBack,
    goTo,
    currentPage: currentPage.page,
    params: currentPage.params,
    currentRoute: Object.values(ROUTES_CONFIG)
      .map((route) => ({
        ...route,
        title: t(route.title),
      }))
      .find(({ path }) => path === currentPage.page)!,
  };
}
